import moment from 'moment';
import React from 'react';

import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import {CalendarEntry, CalendarRequest} from 'calendar/CalendarConstants';
import ProcessTaskSummary from 'calendar/ProcessTaskSummary';

import {ProcessTaskForCalendarGraphQL} from '../../graphql-fragments/processes/__generated/ProcessTaskForCalendarGraphQL';
import CalendarUtil from './CalendarUtil';
import EntryExcerpt from './EntryExcerpt';
import RequestSummary from './RequestSummary';

function getNoneText(): string {
  const modules = [
    {
      label: 'entries',
      isEnabled: () => true,
    },
    {
      label: 'workflow tasks',
      isEnabled: () => isFeatureEnabled({feature: ProcessesFeature.PROCESSES_SHOW_DETAILS}),
    },
    {
      label: 'requests',
      isEnabled: () => BenchlingConfig.ENABLE_REQUESTS,
    },
  ];

  const noTextNames = modules.filter(({isEnabled}) => isEnabled()).map(({label}) => label);
  if (noTextNames.length === 1) {
    return `No ${noTextNames[0]}`;
  }
  const prefix = noTextNames.slice(0, -1).join(', ');
  const suffix = noTextNames[noTextNames.length - 1];
  return `No ${prefix}${noTextNames.length > 2 ? ',' : ''} or ${suffix}`;
}

export default function DailyProjectActivity(props: {
  date: moment.Moment;
  entries: Array<CalendarEntry>;
  requests: Array<CalendarRequest>;
  processTasks: Array<ProcessTaskForCalendarGraphQL>;
  isLoadingData: boolean;
}): JSX.Element {
  if (!CalendarUtil.hasCalendarItems(props.entries, props.requests, props.processTasks)) {
    return <div className="calendarDay-noEntries u-spacing-bottom">{getNoneText()}</div>;
  }
  return (
    <>
      {CalendarUtil.sortCalendarItems(props.entries).map((entry) => (
        <EntryExcerpt key={entry.id} entry={entry} date={props.date} isLoadingData={props.isLoadingData} />
      ))}
      {BenchlingConfig.ENABLE_REQUESTS &&
        CalendarUtil.sortCalendarItems(props.requests).map((request) => (
          <RequestSummary key={request.id} request={request} />
        ))}
      {isFeatureEnabled({feature: ProcessesFeature.PROCESSES_SHOW_DETAILS}) &&
        CalendarUtil.sortCalendarItems(props.processTasks).map((processTask) => (
          <ProcessTaskSummary key={processTask.id} processTask={processTask} />
        ))}
    </>
  );
}
